'use client'

import { show as showIntercom } from '@intercom/messenger-js-sdk'
import { ArrowUpRight } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

const actionClassName =
  'group flex w-fit items-center gap-3 text-sm font-medium tracking-[-0.28px] text-white hover:underline decoration-dotted underline-offset-3 transition-colors hover:text-ox-cyan'
const iconClassName =
  'size-4 shrink-0 text-ox-cyan transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5'

export function NotFoundActions() {
  const t = useTranslations('notFound')
  return (
    <div className="flex flex-col gap-4">
      <Link
        href="https://orderx.com"
        target="_blank"
        rel="noopener noreferrer"
        className={actionClassName}
      >
        <ArrowUpRight className={iconClassName} />
        <span>{t('returnHome')}</span>
      </Link>
      <Link href="/trade" className={actionClassName}>
        <ArrowUpRight className={iconClassName} />
        <span>{t('explorePlatform')}</span>
      </Link>
      <button type="button" onClick={() => showIntercom()} className={actionClassName}>
        <ArrowUpRight className={iconClassName} />
        <span>{t('contactTeam')}</span>
      </button>
    </div>
  )
}
